import session from "../../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../../services/api'

const AdminApiService = new AdminApi();

export default {
    data() {
        return {
            paymentId: 0,
            debtor : 0,
            model: {
                expireDate: null,
                paidDate: null,
                paidMoney: 0,
                types: []
            },
            types: []
        }
    },
    methods: {
        editPayment: editPayment,
        loadPayment: loadPayment,
        formatDate: formatDate,
        getTrainingTypes: getTrainingTypes,
        onChangeCheckBox: onChangeCheckBox,
        setSelectedCheckBox: setSelectedCheckBox
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push('/home');
            return;
        }
        this.paymentId = this.$route.query.id;
        this.loadPayment();

        // this.getTrainingTypes();
    }
}

function editPayment() {
    let _self = this;
    if(_self.model.types.length === 0){
        swal('Greška','Izaberite tip treninga', 'error')
        return;
    }
    _self.model.paidMoney = this.model.paidMoney;
    _self.model.paidDate = this.model.paidDate + 'T00:00:00.000Z';
    _self.model.expireDate = this.model.expireDate + 'T00:00:00.000Z';
    AdminApiService.updatePayment(_self.model, _self.paymentId)
        .then((response) => {
            swal('Uspešno', 'Uspešno izmenjena uplata.', 'success')
            this.$router.back()
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function loadPayment() {
    let _self = this;
    AdminApiService.getPaymentById(this.paymentId)
        .then((response) => {
            _self.model = response.data
            if(response.data.paidMoney > 0){
                _self.debtor = 1
            }else {
                _self.debtor = 0
            }
            _self.model.expireDate = _self.formatDate(_self.model.expireDate)
            _self.model.paidDate = _self.formatDate(_self.model.paidDate)
            _self.model.types = response.data.trainingTypes.split(',')
            _self.getTrainingTypes();
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function setSelectedCheckBox(key) {
    return this.model.types.indexOf(key) > -1
}

function onChangeCheckBox(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.types.indexOf(key) < 0){
            this.model.types.push(key);
        }
    }else{
        const index = this.model.types.indexOf(key);
        if (index > -1) {
            this.model.types.splice(index, 1);
        }
    }
}


function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('YYYY-MM-DD')
}


// WEBPACK FOOTER //
// ./src/components/Users/Payment/Edit/EditPayment.js